
export function random(min:number, max:number): number {
    return min + Math.random()*(max-min);
}

export function randomDirection(): number {
    return random(0, 2 * Math.PI);
}

